import React, { useState, useEffect } from 'react'
import './RutaVendedoresContainer.css'
import MaterialTable from 'material-table'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  TextField,
} from '@material-ui/core'
import { Edit, Visibility, RemoveCircle, CheckCircle } from '@material-ui/icons'

const RutaVendedoresContainer = () => {
  const [vendedores, setVendedores] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [openAddDialog, setOpenAddDialog] = useState(false)
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [selectedVendedor, setSelectedVendedor] = useState(null)
  const [newVendedor, setNewVendedor] = useState({
    cc: '',
    nombre: '',
    celular: '',
    punto_venta: '',
    correo: '',
  })

  // Simulated data - replace with actual API call
  const getVendedoresData = async () => {
    setIsLoading(true)
    // Simulated API response
    const response = {
      vendedores: [
        {
          cc: '100942301',
          nombre: 'Felipe Auteco',
          celular: '3114567912',
          punto_venta: 'Bogota DC',
          correo: 'felipe@gmail.com',
          bloqueado: false
        },
        {
          cc: '100942301',
          nombre: 'Santiago Auteco',
          celular: '3114567912',
          punto_venta: 'Bogota DC',
          correo: 'santiago@gmail.com',
          bloqueado: true
        },
        {
          cc: '100942301',
          nombre: 'Carlos Auteco',
          celular: '3114567912',
          punto_venta: 'Bogota DC',
          correo: 'carlos@gmail.com',
          bloqueado: true
        },
        {
          cc: '100942301',
          nombre: 'Pedro Auteco',
          celular: '3114567912',
          punto_venta: 'Bogota DC',
          correo: 'pedro@gmail.com',
          bloqueado: false
        }
      ]
    }
    
    setVendedores(response.vendedores)
    setIsLoading(false)
  }

  useEffect(() => {
    getVendedoresData()
  }, [])

  const handleAddVendedor = () => {
    // Add validation here
    setVendedores([...vendedores, { ...newVendedor, bloqueado: false }])
    setOpenAddDialog(false)
    setNewVendedor({
      cc: '',
      nombre: '',
      celular: '',
      punto_venta: '',
      correo: '',
    })
  }

  const handleEditClick = (rowData) => {
    setSelectedVendedor(rowData)
    setOpenEditDialog(true)
  }

  const handleEditVendedor = () => {
    const updatedVendedores = vendedores.map(vendedor =>
      vendedor.cc === selectedVendedor.cc && vendedor.nombre === selectedVendedor.nombre
        ? selectedVendedor
        : vendedor
    )
    setVendedores(updatedVendedores)
    setOpenEditDialog(false)
    setSelectedVendedor(null)
  }

  const handleToggleBlock = (rowData) => {
    const updatedVendedores = vendedores.map(vendedor => 
      vendedor.cc === rowData.cc && vendedor.nombre === rowData.nombre
        ? { ...vendedor, bloqueado: !vendedor.bloqueado }
        : vendedor
    )
    setVendedores(updatedVendedores)
  }

  const AddVendedorDialog = () => (
    <Dialog
      open={openAddDialog}
      onClose={() => setOpenAddDialog(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Agregar Vendedor</DialogTitle>
      <DialogContent>
        <div className="form-container">
          <TextField
            fullWidth
            label="CC"
            value={newVendedor.cc}
            onChange={(e) => setNewVendedor({ ...newVendedor, cc: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Nombre"
            value={newVendedor.nombre}
            onChange={(e) => setNewVendedor({ ...newVendedor, nombre: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Celular"
            value={newVendedor.celular}
            onChange={(e) => setNewVendedor({ ...newVendedor, celular: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Punto de Venta"
            value={newVendedor.punto_venta}
            onChange={(e) => setNewVendedor({ ...newVendedor, punto_venta: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Correo"
            type="email"
            value={newVendedor.correo}
            onChange={(e) => setNewVendedor({ ...newVendedor, correo: e.target.value })}
            margin="normal"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenAddDialog(false)} color="default">
          Cancelar
        </Button>
        <Button onClick={handleAddVendedor} color="primary">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  )

  const EditVendedorDialog = () => (
    <Dialog
      open={openEditDialog}
      onClose={() => setOpenEditDialog(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Editar Vendedor</DialogTitle>
      <DialogContent>
        <div className="form-container">
          <TextField
            fullWidth
            label="CC"
            value={selectedVendedor?.cc || ''}
            onChange={(e) => setSelectedVendedor({ ...selectedVendedor, cc: e.target.value })}
            margin="normal"
            disabled // CC field should not be editable
          />
          <TextField
            fullWidth
            label="Nombre"
            value={selectedVendedor?.nombre || ''}
            onChange={(e) => setSelectedVendedor({ ...selectedVendedor, nombre: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Celular"
            value={selectedVendedor?.celular || ''}
            onChange={(e) => setSelectedVendedor({ ...selectedVendedor, celular: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Punto de Venta"
            value={selectedVendedor?.punto_venta || ''}
            onChange={(e) => setSelectedVendedor({ ...selectedVendedor, punto_venta: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Correo"
            type="email"
            value={selectedVendedor?.correo || ''}
            onChange={(e) => setSelectedVendedor({ ...selectedVendedor, correo: e.target.value })}
            margin="normal"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenEditDialog(false)} color="default">
          Cancelar
        </Button>
        <Button onClick={handleEditVendedor} color="primary">
          Guardar Cambios
        </Button>
      </DialogActions>
    </Dialog>
  )

  return (
    <div className="vendedores-container">
      <div className="header-info">
        <Typography variant="h5">
          Vendedores
        </Typography>
      </div>

      <div className={`table-container ${isLoading ? 'loading' : ''}`}>
        <div className="actions-header">
          {/* <Button
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={() => setOpenAddDialog(true)}
          >
            Agregar
          </Button> */}
        </div>

        <MaterialTable
          title=""
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 20, 50],
            headerStyle: {
              backgroundColor: '#F6F6F6',
              color: '#161615',
              fontSize: '14px',
              fontWeight: 700,
            },
            actionsColumnIndex: -1,
            search: true,
          }}
          columns={[
            { title: 'CC', field: 'cc' },
            { title: 'Nombre', field: 'nombre' },
            { title: 'Celular', field: 'celular' },
            { title: 'Punto de Venta', field: 'punto_venta' },
            { title: 'Correo', field: 'correo' },
            {
              title: 'Ver',
              render: () => (
                <IconButton>
                  <Visibility style={{ color: '#3f51b5' }} />
                </IconButton>
              ),
              width: 70
            },
            {
              title: 'Editar',
              render: (rowData) => (
                <IconButton onClick={() => handleEditClick(rowData)}>
                  <Edit style={{ color: '#757575' }} />
                </IconButton>
              ),
              width: 70
            },
            {
              title: 'Bloqueado',
              render: (rowData) => (
                <IconButton onClick={() => handleToggleBlock(rowData)}>
                  {rowData.bloqueado ? (
                    <RemoveCircle style={{ color: '#f44336' }} />
                  ) : (
                    <CheckCircle style={{ color: 'green' }} />
                  )}
                </IconButton>
              ),
              width: 70
            }
          ]}
          data={vendedores}
        />
      </div>

      <AddVendedorDialog />
      <EditVendedorDialog />
    </div>
  )
}

export default RutaVendedoresContainer